import { useToast as useDesignSystemToast } from '@cplug/design-system/composables'
import type { ToastAddMessage } from '@cplug/design-system/composables'
import type { BaseError } from '@cplug/frontend-core/models'
import { ToastLifeTime } from '~/shared/components/atoms/Toast'

export interface ToastOptions {
  life?: ToastLifeTime
  detail?: string
  group?: string
}

export interface ToastComposable {
  success: (message: string, options?: ToastOptions) => void
  error: (error: BaseError | string, options?: ToastOptions) => void
  info: (message: string, options?: ToastOptions) => void
  warn: (message: string, options?: ToastOptions) => void
  notify: (message: string, options?: ToastOptions) => void
  clear: (group?: string) => void
  add: (message: ToastAddMessage) => void
}

export function useToast (): ToastComposable {
  const toast = useDesignSystemToast()

  function error (errorValue: BaseError | string, options: ToastOptions = {}): void {
    const message = typeof errorValue === 'string' ? errorValue : (errorValue.message ?? 'Erro')
    toast.error(message, options)
  }

  return {
    ...toast,
    error
  }
}
